var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Book mb-16"},[_c('h1',{staticClass:"text-center dastnevis my-10"},[_vm._v(" مجموعه کتاب های بسته توسعه سواد خواندن ")]),_vm._l((_vm.series),function(item){return _c('div',{key:item.name,staticClass:"py-16"},[_c('BookList',{attrs:{"series":item.name,"grade":item.grade,"right":item.right}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }